import { useEffect, useState } from "react";
import { LoadingState, LoadingStateOps } from "../domain/data-layer/loading-state";

export function useExternalScript<T>(script: { src: string; async: boolean }, acquire: () => T): LoadingState<T> {
  const [loadingState, setState] = useState<LoadingState<T>>(LoadingStateOps.loadingS);

  useEffect(() => {
    const onLoad = () => {
      setState(LoadingStateOps.asLoaded(acquire()));
    };
    const onError = () => {
      setState(LoadingStateOps.asFailed("error"));
    };

    const el = document.createElement("script");
    el.src = script.src;
    el.onload = () => {
      onLoad();
    };
    el.onerror = () => {
      onError();
    };
    el.async = script.async;

    document.body.appendChild(el);

    return () => {
      document.body.removeChild(el);
    };
  }, [script.src]);

  return loadingState;
}
